/* ── Custom Cursor (desktop only) ── */
(function(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  const dot=document.getElementById('cur-dot'),ring=document.getElementById('cur-ring');
  dot.style.display=ring.style.display='block';
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px'});
  (function tick(){rx+=(mx-rx)*.11;ry+=(my-ry)*.11;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(tick)})();
  const sel='a,button,.mcard,.ccard,.reel,.ytcard,.bcard,.ig-cell,.rc,.ml';
  document.querySelectorAll(sel).forEach(el=>{
    el.addEventListener('mouseenter',()=>document.body.classList.add('hov'));
    el.addEventListener('mouseleave',()=>document.body.classList.remove('hov'));
  });
})();

/* ── Nav solid on scroll ── */
const nav=document.getElementById('nav');
if(nav){
  const onScroll=()=>nav.classList.toggle('solid',window.scrollY>60);
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
}

/* ── Drawer ── */
const ham=document.getElementById('ham'),drw=document.getElementById('drw');
if(ham&&drw){
  ham.addEventListener('click',()=>{
    const open=ham.classList.toggle('open');
    drw.classList.toggle('open',open);
    document.body.style.overflow=open?'hidden':'';
  });
  window.closeDrw=function(){
    ham.classList.remove('open');drw.classList.remove('open');document.body.style.overflow='';
  };
  drw.addEventListener('click',e=>{if(e.target===drw)closeDrw()});
}

/* ── Slideshow ── */
let cur=0,total=document.querySelectorAll('.slide').length||3,timer;
const prog=document.getElementById('prog'),slideNum=document.getElementById('slideNum');
if(prog&&total>0){
  window.goSlide=function(n){
    document.getElementById('sl'+cur)?.classList.remove('active');
    document.querySelectorAll('.dot')[cur]?.classList.remove('active');
    cur=((n%total)+total)%total;
    document.getElementById('sl'+cur)?.classList.add('active');
    document.querySelectorAll('.dot')[cur]?.classList.add('active');
    if(slideNum)slideNum.textContent=String(cur+1).padStart(2,'0');
    prog.classList.remove('run');
    void prog.offsetWidth;
    prog.classList.add('run');
  };
  timer=setInterval(()=>goSlide(cur+1),5000);
  const heroEl=document.querySelector('.hero');
  if(heroEl){
    let touchX=0;
    heroEl.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].screenX},{passive:true});
    heroEl.addEventListener('touchend',e=>{
      const d=e.changedTouches[0].screenX-touchX;
      if(Math.abs(d)>48){clearInterval(timer);goSlide(d<0?cur+1:cur-1);timer=setInterval(()=>goSlide(cur+1),5000);}
    },{passive:true});
  }
}

/* ── Scroll Reveal ── */
const observer=new IntersectionObserver(entries=>{
  entries.forEach((entry,i)=>{
    if(entry.isIntersecting){
      setTimeout(()=>{entry.target.classList.add('on');entry.target.style.transitionDelay='0s'},i*55);
      observer.unobserve(entry.target);
    }
  });
},{threshold:.07,rootMargin:'0px 0px -20px 0px'});
document.querySelectorAll('.rv,.rv-x').forEach(el=>observer.observe(el));

/* ── Stat counter ── */
function countUp(el,to,suffix){
  const start=performance.now(),dur=1800;
  (function frame(now){
    const p=Math.min((now-start)/dur,1),ease=1-Math.pow(1-p,3);
    el.textContent=Math.floor(ease*to)+suffix;
    if(p<1)requestAnimationFrame(frame);
  })(start);
}
const statsObs=new IntersectionObserver(entries=>{
  if(!entries[0].isIntersecting)return;
  document.querySelectorAll('.rc-n[data-to]').forEach(el=>{countUp(el,+el.dataset.to,el.dataset.sf||'')});
  statsObs.disconnect();
},{threshold:.5});
const ribbon=document.querySelector('.ribbon');
if(ribbon)statsObs.observe(ribbon);

/* ── Dealer Form ── */
window.handleSubmit=function(btn){
  const form=btn.closest('.deal-r')||btn.parentElement;
  const name=form.querySelector('input[type="text"]')?.value?.trim();
  const phone=form.querySelector('input[type="tel"]')?.value?.trim();
  const email=form.querySelector('input[type="email"]')?.value?.trim();
  if(!name||!phone){alert('Please fill in your name and phone number.');return;}
  btn.disabled=true;btn.textContent='Submitting…';
  setTimeout(()=>{
    btn.textContent='✓ Application Received!';
    btn.style.background='var(--t6)';
    const note=form.querySelector('.form-note');
    if(note)note.textContent='Our team will call you within 24 hours.';
  },1200);
};
